<template>
  <v-card v-if="opened" :width="width" :class="`container--fluid ibis-messagebox ${outerclass}`" flat tile>
    <v-card :class="`${innerclass}`" flat class="d-flex inner">
      <v-card-actions class="message-icon">
        <v-icon >{{ boxicon }}</v-icon>
      </v-card-actions>
      <div>
        <slot></slot>
      </div>
      <v-card-actions class="close-icon" v-if="closable">
        <v-icon @click="opened=false; $emit('closed')">$sl-close</v-icon>
      </v-card-actions>
    </v-card>
    <!-- <v-card :class="`${innerclass}`" flat>
      <v-row no-gutters>
        <v-col cols="1" class="message-icon-col my-3 ml-3 mr-2">
          <v-icon>{{ boxicon }}</v-icon>
        </v-col>
        <v-col :cols="closable ? 9 : 10" class="ibis-messagebox__content">
         
          <slot></slot>
        </v-col>
        <v-col v-if="closable" cols="2" class="mt-2 d-flex justify-flex-end"></v-col>
      </v-row>
    </v-card> -->
  </v-card>
</template>

<script>
// @group Common
// Styled MessageBox component

export default {
  name:'MessageBox',
  props: {
    // The type of the MessageBox
    type: {
      // `'info'` / `'alert'` / `'warning'`
      type: String,
      // The default value is: `info`
      default: 'info'
    },
    // Is the MessageBox closable
    closable: {
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    width: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    opened: true
  }),

  computed: {
    outerclass() {
      switch (this.type) {
        case 'alert':
          return 'alert'
          break
        case 'warning':
          return 'warning'
          break
        default:
          return 'info'
      }
    },
    innerclass() {
      switch (this.type) {
        case 'alert':
          return 'alert'
          break
        case 'warning':
          return 'warning'
          break
        default:
          return 'info'
      }
    },
    boxicon() {
      switch (this.type) {
        case 'alert':
          return '$sl-alert'
          break
        case 'warning':
          return '$sl-warning'
          break
        default:
          return '$sl-info'
      }
    }
  }
}
</script>

<style>
</style>